import { render, staticRenderFns } from "./bookmarks.vue?vue&type=template&id=299f5800&scoped=true"
import script from "./bookmarks.vue?vue&type=script&lang=ts"
export * from "./bookmarks.vue?vue&type=script&lang=ts"
import style0 from "./bookmarks.vue?vue&type=style&index=0&id=299f5800&prod&lang=scss&scoped=true"
import style1 from "./bookmarks.vue?vue&type=style&index=1&id=299f5800&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "299f5800",
  null
  
)

export default component.exports